import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import { __rest as e } from "../_virtual/_tslib.js";
import { jsx as t, jsxs as o } from "react/jsx-runtime";
import { Component as i } from "react";
import n from "styled-components";
import { ScrollWrapper as r } from "@vds-core/scrollbars";
import { calculateRem as l, getOS as s } from "@vds-core/utilities";
import { ColorTokens as a } from "@vds-tokens/color";
import { LayoutTokens as d } from "@vds-tokens/layout";
import { Fonts as c } from "@vds-core/typography";
import { TypographyTokens as p } from "@vds-tokens/typography";
import { AccessibilityTokens as u } from "@vds-tokens/accessibility";
import { updateDialogPosition as h } from "../utils/position-util.js";
var f = function f(e) {
    var t;
    return t = "dark" === e ? a.interactive.scrolltrack.ondark.value : a.interactive.scrolltrack.onlight.value, t;
  },
  m = function m(e, t) {
    var o;
    return o = "dark" !== e || t ? t && "dark" !== e ? a.interactive.scrollthumb.hover.onlight.value : t && "dark" === e ? a.interactive.scrollthumb.hover.ondark.value : a.interactive.scrollthumb.onlight.value : a.interactive.scrollthumb.ondark.value, o;
  },
  g = function g(e) {
    var t = "string" == typeof e ? parseInt(e, 10) : e;
    return t ? t <= 108 ? 108 : t >= 204 ? 204 : t : 204;
  },
  v = n.span.withConfig({
    displayName: "DialogWrapper",
    componentId: "VDS__sc-1688c4c-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  border-radius: ", ";\n  background-color: ", ";\n  border: ", ";\n  color: ", ";\n  left: ", ";\n  position: absolute;\n  overflow: visible;\n  padding: ", ";\n  min-height: ", ";\n  max-height: ", ";\n  max-width: ", ";\n  -ms-overflow-style: none; /* disable scroll bar ie11*/\n  text-align: left;\n  transform: translateX(-50%);\n  visibility: ", ";\n  width: ", ";\n  will-change: transform, left;\n  z-index: ", ";\n  outline: none;\n  &::before {\n    content: '';\n    position: absolute;\n    box-sizing: border-box;\n    border-right: ", " solid\n      ", ";\n    border-bottom: ", " solid\n      ", ";\n    width: ", ";\n    height: ", ";\n    bottom: ", ";\n    background: ", ";\n    left: ", ";\n    transform: translate(-50%) rotate(45deg);\n    will-change: transform, left;\n    z-index: -1;\n\n    /* position fix for safari browsers */\n    @media not all and (min-resolution: 0.001dpcm) {\n      @supports (-webkit-appearance: none) {\n        width: ", ";\n        height: ", ";\n        bottom: ", ";\n      }\n    }\n    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n      width: ", ";\n      height: ", ";\n      bottom: ", ";\n    }\n    /* position fix for FF browsers */\n    @-moz-document url-prefix() {\n      bottom: ", ";\n    }\n  }\n\n  ", ";\n\n  * ::-webkit-scrollbar {\n    display: none;\n  }\n\n  * {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n"])), function (_ref) {
    var e = _ref.$tooltipBorderRadius;
    return e;
  }, function (_ref2) {
    var e = _ref2.surface;
    return "dark" === e ? a.background.primary.dark.value : a.background.primary.light.value;
  }, function (_ref3) {
    var e = _ref3.surface;
    return "solid ".concat(l(1), " ").concat("dark" === e ? a.elements.primary.ondark.value : a.elements.primary.onlight.value);
  }, function (_ref4) {
    var e = _ref4.surface;
    return "dark" === e ? a.elements.primary.ondark.value : a.elements.primary.onlight.value;
  }, function (_ref5) {
    var e = _ref5.$positionDialog;
    return null == e ? void 0 : e();
  }, l(d.space["3X"].value, 0, d.space["3X"].value, d.space["3X"].value), l(40), function (_ref6) {
    var e = _ref6.$maxHeight;
    return l(e);
  }, l(224), function (_ref7) {
    var e = _ref7.$showDialog;
    return e ? "visible" : "hidden";
  }, l(224), function (_ref8) {
    var e = _ref8.$clicked;
    return e ? 998 : 999;
  }, l(1), function (_ref9) {
    var e = _ref9.surface;
    return "dark" === e ? a.elements.primary.ondark.value : a.elements.primary.onlight.value;
  }, l(1), function (_ref0) {
    var e = _ref0.surface;
    return "dark" === e ? a.elements.primary.ondark.value : a.elements.primary.onlight.value;
  }, l(8.5), l(8.5), l(-4.5), function (_ref1) {
    var e = _ref1.surface;
    return "dark" === e ? a.background.primary.dark.value : a.background.primary.light.value;
  }, function (_ref10) {
    var e = _ref10.$positionCaret;
    return e && e();
  }, l(9), l(9), l(-5), l(8.5), l(8.5), l(-4.5), l(-5), function (e) {
    return h(e);
  }),
  b = {
    medium: 13,
    large: 13,
    small: 12
  },
  y = n.span.withConfig({
    displayName: "InnerDialogWithScroll",
    componentId: "VDS__sc-1688c4c-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  overflow: visible; /* necessary for ie11 support to show focus-state */\n  position: relative;\n"]))),
  w = n.span.withConfig({
    displayName: "ScreenReaderText",
    componentId: "VDS__sc-1688c4c-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"]))),
  $ = n.span.withConfig({
    displayName: "InnerDialogWithScrollContentWrapper",
    componentId: "VDS__sc-1688c4c-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  width: auto;\n  padding-right: ", ";\n  &:focus,\n  &.js-focus-visible :focus:not(.focus-visible) {\n    outline: none;\n\n    &::after {\n      content: '';\n      border: ", ";\n      height: calc(100% - 28px);\n      left: ", ";\n      position: absolute;\n      width: ", ";\n      top: ", ";\n    }\n  }\n\n  span {\n    -ms-overflow-style: none; /* Internet Explorer 10+ */\n    scrollbar-width: none; /* Firefox */\n  }\n\n  span ::-webkit-scrollbar {\n    /* Safari and Chrome */\n    -webkit-appearance: none;\n    width: 0px;\n  }\n"])), d.space["1X"].value, function (_ref11) {
    var e = _ref11.$keyboardFocused;
    return e ? "".concat(l(1), " dotted ").concat(u.color.focusring.onlight.value) : "";
  }, l(12), l(198), l(12)),
  C = n.span.withConfig({
    displayName: "InnerDialogWithoutScroll",
    componentId: "VDS__sc-1688c4c-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  outline: none;\n  padding-right: ", ";\n  box-sizing: border-box;\n  &:focus {\n    outline: none;\n  }\n"])), d.space["3X"].value),
  k = n.span.withConfig({
    displayName: "TextWrapper",
    componentId: "VDS__sc-1688c4c-5"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  display: inline;\n  width: 100%;\n"])), function (_ref12) {
    var e = _ref12.$isIe;
    return !e && "\n      flex-direction: column;\n    ";
  }),
  D = n.span.withConfig({
    displayName: "StyledHeading",
    componentId: "VDS__sc-1688c4c-6"
  })(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  margin: 0;\n  margin-bottom: ", ";\n"])), c.VerizonNHGeTX, p.fontsize.body[12].value, p.lineheight.body[16].value, p.fontweight.bold.value, d.space["1X"].value),
  x = n.span.withConfig({
    displayName: "StyledContent",
    componentId: "VDS__sc-1688c4c-7"
  })(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  margin: 0;\n  word-break: break-word;\n  letter-spacing: normal;\n"])), c.VerizonNHGeTX, p.fontsize.body[12].value, p.lineheight.body[16].value),
  I = n.div.withConfig({
    displayName: "ContentWrapper",
    componentId: "VDS__sc-1688c4c-8"
  })(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var S = /*#__PURE__*/function (_i) {
  _inherits(S, _i);
  function S(e) {
    var _this;
    _classCallCheck(this, S);
    var i;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(S).call(this, e)), i = _assertThisInitialized(_assertThisInitialized(_this)), _this.isOsx = "osx" === s(), _this.doUpdatedCoordinates = !0, _this.getScrollParent = function (e) {
      return null == e || e === document.body ? document : e.scrollHeight > e.clientHeight && e !== document.getElementById(i.props.tooltipWrapperId) ? e : i.getScrollParent(e.parentNode);
    }, _this._trackKeys = function (e) {
      var t, o, n, r;
      if (e.target.id !== "scrollbar-view-".concat(i.props.scrollbarId) || 13 !== e.keyCode && 32 !== e.keyCode) {
        if (9 === e.keyCode || 27 === e.keyCode) return e.stopPropagation(), void (null === (r = (n = i.props).handleTabKeyPress) || void 0 === r || r.call(n, e));
        if (i.props.showDialog && i.props.hasScrollableContent && 40 === e.keyCode) {
          e.preventDefault();
          ("undefined" != typeof document && document.getElementById("scrollbar-view-".concat(i.props.scrollbarId))).scrollTop += 16;
        }
        if (i.props.showDialog && i.props.hasScrollableContent && 38 === e.keyCode) {
          e.preventDefault();
          ("undefined" != typeof document && document.getElementById("scrollbar-view-".concat(i.props.scrollbarId))).scrollTop -= 16;
        }
      } else null === (o = (t = i.props).onPopoverKeyDown) || void 0 === o || o.call(t, e, !1);
    }, _this.setDialogElementPositionProperties = function () {
      var e = i.tooltipContentRef,
        t = e && e.getBoundingClientRect();
      i.setState({
        dialogElementCoordinates: t
      });
    }, _this.positionDialogContentVertical = function () {
      var e;
      var t = null === (e = i.props.toolTipAnchorRef) || void 0 === e ? void 0 : e.getBoundingClientRect(),
        o = i.tooltipContentRef && i.tooltipContentRef.offsetHeight,
        n = i.props.containerId && "undefined" != typeof document && document.getElementById(i.props.containerId);
      var r = !1;
      if (n) {
        var _e = n.getBoundingClientRect().top;
        r = (t.top && t.top - o) < _e;
      }
      !(t.top && t.top > o) || r ? i.setState({
        isDialogOnTop: !1
      }) : i.setState({
        isDialogOnTop: !0
      });
    }, _this.positionDialogContentHorizontal = function () {
      var e = 20,
        _i$props$tooltipAncho = i.props.tooltipAnchorCoordinates,
        t = _i$props$tooltipAncho.left,
        o = _i$props$tooltipAncho.right,
        _i$state$dialogElemen = i.state.dialogElementCoordinates,
        n = _i$state$dialogElemen.width,
        r = _i$state$dialogElemen.left,
        l = _i$state$dialogElemen.right,
        s = n / 2,
        a = "undefined" != typeof window && window.innerWidth - e - r - s,
        d = s - e + 4,
        c = i.state.size ? b[i.state.size] : 0,
        p = i.props.containerId && "undefined" != typeof document && document.getElementById(i.props.containerId);
      if (p) {
        var _t = p.getBoundingClientRect(),
          _o = l + e > _t.right;
        var _n = 0;
        return r - e < _t.left && (_n = _t.left - r + e), _o && (_n = _t.right - l - e), void i.setState({
          dialogHorizontalPosition: _n
        });
      }
      if (s > t) {
        var _o2 = t <= e ? s - e + c : s - t + c;
        i.setState({
          dialogHorizontalPosition: _o2
        });
      } else if ("undefined" != typeof window && window.innerWidth - s > o) i.setState({
        dialogHorizontalPosition: 0
      });else {
        var _e2 = Math.abs(o - s) > d ? -1 * d + c : a - s + c;
        i.setState({
          dialogHorizontalPosition: _e2
        });
      }
    }, _this.tooltipDialogContentHeight = function () {
      var e, t, o;
      var n = i.tooltipContentRef.offsetHeight - 11;
      null === (t = (e = i.props).setHasScrollableContent) || void 0 === t || t.call(e, (null === (o = i.contentRef) || void 0 === o ? void 0 : o.offsetHeight) >= n);
    }, _this._positionCaret = function () {
      var _i$props = i.props,
        e = _i$props.customAnchorPresent,
        t = _i$props.tooltipAnchorCoordinates,
        o = i.state.dialogHorizontalPosition;
      var n = o;
      return o > 93 && (n = 94), o < -93 && (n = -94), e ? t && t.width > i.state.dialogElementCoordinates.width ? "50%" : "calc(50% - ".concat(n, "px);") : "calc(50% - ".concat(n - 2, "px);");
    }, _this._positionDialog = function () {
      var _i$props2 = i.props,
        e = _i$props2.customAnchorPresent,
        t = _i$props2.tooltipAnchorCoordinates,
        o = i.state.dialogHorizontalPosition;
      var n = o;
      return o > 93 && (n = 94), o < -93 && (n = -94), e ? t && t.width > i.state.dialogElementCoordinates.width ? "50%" : "calc(50% + ".concat(n, "px);") : "calc(50% + ".concat(n + 2, "px);");
    }, _this._handleMouseEnter = function () {
      var e, t;
      null === (t = (e = i.props).keepDialogActiveOnMouseEnter) || void 0 === t || t.call(e);
    }, _this._handleMouseLeave = function (e) {
      var t, o;
      if (i.props.clicked) return null;
      null === (o = (t = i.props).deactivateDialogState) || void 0 === o || o.call(t, e);
    }, _this.renderTooltipPopoverWithScroll = function () {
      var e = g(i.props.maxHeight) - 26;
      return t(y, {
        children: t($, {
          id: i.props.ariaId,
          $keyboardFocused: i.props.keyboardFocused,
          "aria-hidden": !!i.props.isIe || void 0,
          children: t(r, {
            height: "".concat(e, "px"),
            width: "100%",
            contentStyle: {
              display: "flex",
              flexDirection: "column",
              paddingRight: d.space["2X"].value,
              margin: 0
            },
            surface: i.props.surface,
            scrollbarId: i.props.scrollbarId,
            calculateTrackColor: f,
            calculateThumbColor: m,
            borderRadius: i.props.scrollbarBorderRadius,
            hitAreaWidth: 4,
            children: o(I, {
              ref: function ref(e) {
                e && (i.contentRef = e);
              },
              children: [i.isOsx && t(w, {
                "aria-hidden": i.state.delayTime,
                children: "Expanded."
              }), i.props.title && t(D, {
                children: i.props.title
              }), i.props.content && t(x, {
                children: i.props.content
              })]
            })
          })
        })
      });
    }, _this.renderDialogWithoutScroll = function () {
      var e = i.props.isIe;
      return t(C, {
        onKeyDown: i.handleDialogUnFocus,
        tabIndex: -1,
        id: i.props.ariaId,
        children: o(I, {
          ref: function ref(e) {
            e && (i.contentRef = e);
          },
          children: [i.isOsx && t(w, {
            "aria-hidden": i.state.delayTime,
            children: "Expanded."
          }), o(k, {
            $isIe: e,
            children: [i.props.title && t(D, {
              children: i.props.title
            }), i.props.content && t(x, {
              children: i.props.content
            })]
          })]
        })
      });
    }, _this._setRef = function (e) {
      var t, o;
      null === (o = (t = i.props).setRef) || void 0 === o || o.call(t, e), i.tooltipContentRef = e;
    }, _this.state = {
      isDialogOnTop: !0,
      dialogHorizontalPosition: 0,
      dialogElementCoordinates: {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0
      },
      size: e.size,
      delayTime: !1
    }, _this.delayTimer = null;
    return _this;
  }
  _createClass(S, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e = this;
      this.doUpdatedCoordinates = !0;
      var t = "undefined" != typeof document ? document.getElementById(this.props.tooltipId) : null;
      "undefined" != typeof window && (window.addEventListener("scroll", this.positionDialogContentHorizontal), window.addEventListener("scroll", this.positionDialogContentVertical), window.addEventListener("resize", this.positionDialogContentHorizontal)), null == t || t.addEventListener("keydown", this._trackKeys), this.setDialogElementPositionProperties(), this.tooltipDialogContentHeight(), this.positionDialogContentVertical(), this.props.keyboardFocused && setTimeout(function () {
        var t = "undefined" != typeof document ? document.getElementById("scrollbar-view-".concat(e.props.scrollbarId)) : null,
          o = "undefined" != typeof document ? document.getElementById("scrollbar-track-".concat(e.props.scrollbarId)) : null;
        if (!e.props.hasAnchorElement && e.props.isFirefox && t) {
          var _t2 = "undefined" != typeof document ? document.querySelectorAll("#scrollbar-view-".concat(e.props.scrollbarId, " span")) : null;
          _t2 && _t2.length > 1 ? (_t2[0].setAttribute("id", "scrollbar-view-header"), _t2[1].setAttribute("id", "scrollbar-view-content")) : null == _t2 || _t2[0].setAttribute("id", "scrollbar-view-content");
        }
        t && (t.setAttribute("tabIndex", "0"), null == o || o.setAttribute("aria-hidden", "true"), t.style.outline = "none", t.style.border = "none");
      }, 200), this.parentScrollableContainer = this.getScrollParent(document.getElementById(this.props.tooltipWrapperId)), this.parentScrollableContainer && this.parentScrollableContainer.addEventListener("scroll", function () {
        e.tooltipContentRef && e.positionDialogContentVertical();
      }), this.delayTimer = setTimeout(function () {
        e.delayTimer = null, e.setState({
          delayTime: !0
        });
      }, this.isOsx ? 300 : 10);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      this.doUpdatedCoordinates && (this.setDialogElementPositionProperties(), this.positionDialogContentHorizontal(), this.doUpdatedCoordinates = !1), this.props.content === e.content && this.props.maxHeight === e.maxHeight || this.tooltipDialogContentHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var e = "undefined" != typeof document ? document.getElementById(this.props.tooltipId) : null;
      "undefined" != typeof window && (window.removeEventListener("scroll", this.positionDialogContentHorizontal), window.removeEventListener("scroll", this.positionDialogContentVertical), window.removeEventListener("resize", this.positionDialogContentHorizontal)), null == e || e.removeEventListener("keydown", this._trackKeys), this.parentScrollableContainer && this.parentScrollableContainer.removeEventListener("scroll", this.positionDialogContentVertical), clearTimeout(this.delayTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var o = this;
      var i = this.state.delayTime,
        n = this.props,
        r = n.hasScrollableContent,
        l = n.tooltipBorderRadius,
        s = n.maxHeight,
        a = n.ariaId,
        d = n.clicked,
        c = n.customAnchorElement,
        p = n.customAnchorPresent,
        u = n.scrollbarBorderRadius,
        h = n.isFirefox,
        f = n.hasAnchorElement,
        m = n.setHasScrollableContent,
        b = n.setRef,
        y = n.deactivateDialogState,
        w = n.keyboardFocused,
        $ = n.tooltipId,
        C = n.keepDialogActiveOnMouseEnter,
        k = n.toolTipAnchorRef,
        D = n.showDialog,
        x = n.isIe,
        I = n.containerId,
        S = n.tooltipWrapperId,
        E = n.onPopoverKeyDown,
        H = n.handleTabKeyPress,
        P = n.scrollbarId,
        R = e(n, ["hasScrollableContent", "tooltipBorderRadius", "maxHeight", "ariaId", "clicked", "customAnchorElement", "customAnchorPresent", "scrollbarBorderRadius", "isFirefox", "hasAnchorElement", "setHasScrollableContent", "setRef", "deactivateDialogState", "keyboardFocused", "tooltipId", "keepDialogActiveOnMouseEnter", "toolTipAnchorRef", "showDialog", "isIe", "containerId", "tooltipWrapperId", "onPopoverKeyDown", "handleTabKeyPress", "scrollbarId"]);
      return t(v, Object.assign({
        $tooltipBorderRadius: l,
        $positionCaret: this._positionCaret,
        $positionDialog: this._positionDialog,
        className: "persistentScrollbar",
        $customAnchorElement: this.props.customAnchorElement,
        $customAnchorPresent: this.props.customAnchorPresent,
        $clicked: this.props.clicked,
        "data-testid": "dialog",
        $isDialogOnTop: this.state.isDialogOnTop,
        onKeyDown: function onKeyDown(e) {
          var t, i;
          null === (i = (t = o.props).onPopoverKeyDown) || void 0 === i || i.call(t, e, !1);
        },
        onMouseEnter: this._handleMouseEnter,
        "aria-hidden": this.isOsx ? void 0 : !i,
        onMouseLeave: this._handleMouseLeave,
        ref: this._setRef,
        role: "text",
        $showDialog: this.props.showDialog,
        surface: this.props.surface
      }, R, {
        title: void 0,
        "data-tooltip": this.props.ariaId,
        $maxHeight: g(s),
        children: r ? this.renderTooltipPopoverWithScroll() : this.renderDialogWithoutScroll()
      }));
    }
  }]);
  return S;
}(i);
S.defaultProps = {
  content: null,
  showDialog: !1,
  clicked: !1,
  customAnchorPresent: !1,
  ariaId: null,
  keyboardFocused: !1,
  toolTipAnchorRef: null,
  size: null,
  title: null,
  surface: "light",
  scrollbarBorderRadius: l(2),
  tooltipBorderRadius: "4px"
};
export { S as default };